import { Box, Button, Flex } from "@chakra-ui/react";

interface Props {
  isCancel?: boolean; 
  showCancel?: boolean;
  onCancel: () => void; 
  onEmail: () => void; 
  isDevolucao?: boolean;
  emailBusy?: boolean;
  emailSending?: boolean;
  emailCooldown?: number;
}

export function Actions({
  isCancel = false,
  showCancel = false,
  onCancel,
  onEmail,
  isDevolucao = false,
  emailBusy = false,
  emailSending = false,
  emailCooldown = 0,
}: Props) {

  return (
    <Box w={"full"} bg={"white"} p={"2"} display={"flex"} flexDir={"column"}>
      <Box
        width={"full"}
        fontSize={"sm"}
        border={"1px solid #ccc"}
        display={"flex"}
        flexDir={"column"}
      >
        <Box
          mt={"-2"}
          ml={1}
          fontWeight={"bold"}
          bg={"white"}
          as={"span"}
          w={"80px"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          Ações
        </Box>
        <Flex px={'8'} py={'4'} gap={8}>
          {
            !isCancel && (
              <>
                {showCancel && (
                  <Button onClick={onCancel} bg={'red.500'} color={'white'} borderRadius={'none'} textTransform={'uppercase'}>
                    {isDevolucao ? 'Devolver Pedido' : 'Cancelar Pedido'}
                  </Button>
                )}
                <Button onClick={onEmail} isDisabled={emailBusy || emailCooldown > 0} isLoading={emailSending} loadingText="Solicitando" bg={'purple'} color={'white'} borderRadius={'none'} textTransform={'uppercase'}>{emailCooldown > 0 ? `Reenviar em ${emailCooldown}s` : "Enviar Email"}</Button>
              </>
            )
          }
          
          <Button onClick={() => window.location.href = "/"} bg={'yellow.200'} color={'black'} borderRadius={'none'} textTransform={'uppercase'}>Voltar ao Inicio</Button>
         </Flex>
      </Box>
    </Box>
  );
}
